module.exports = {"TXTWCL_Update_Currency":{"id":"TXTWCL_Update_Currency","defaultMessage":"Mettre à jour la devise"}}